import React from "react";

const Instagram = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M17.996 12.664A5.347 5.347 0 0012.66 18a5.347 5.347 0 005.336 5.335A5.347 5.347 0 0023.33 18a5.347 5.347 0 00-5.335-5.336zM33.998 18c0-2.21.02-4.4-.104-6.605-.124-2.561-.708-4.835-2.581-6.708-1.878-1.877-4.147-2.458-6.709-2.582-2.21-.124-4.399-.104-6.604-.104-2.21 0-4.4-.02-6.605.104-2.561.124-4.835.709-6.708 2.582-1.877 1.877-2.458 4.147-2.582 6.708-.124 2.21-.104 4.4-.104 6.605s-.02 4.399.104 6.604c.124 2.562.709 4.835 2.582 6.708 1.877 1.878 4.147 2.458 6.708 2.582 2.21.124 4.4.104 6.605.104 2.21 0 4.399.02 6.604-.104 2.562-.124 4.835-.708 6.709-2.582 1.877-1.877 2.457-4.146 2.581-6.708.128-2.205.104-4.395.104-6.604zm-16.002 8.21A8.198 8.198 0 019.786 18a8.198 8.198 0 018.21-8.21 8.198 8.198 0 018.21 8.21 8.198 8.198 0 01-8.21 8.21zM26.54 11.37a1.915 1.915 0 01-1.917-1.917c0-1.06.857-1.917 1.917-1.917a1.915 1.915 0 011.772 2.651 1.916 1.916 0 01-1.772 1.183z"
            fill={fill}
        />
    </svg>
);

export default Instagram;
